import { StandardEvents } from '@shopify/events';

/**
 * What happens after the PDP buy sections add to the cart.
 *
 * Desktop opens the cart drawer from the side; mobile goes to the full cart
 * page, where the checkout button is reachable with a thumb instead of behind a
 * panel. This is deliberately NOT settings.auto_open_cart_drawer: that setting
 * is one behaviour for every viewport and for every add in the store, and the
 * split is the whole point here.
 *
 * Scoped to the two ghp buy sections by the hosts below, so an add coming from
 * anywhere else — a quantity bump inside the drawer, a quick-add on a
 * collection — keeps the theme's own behaviour.
 *
 * The module is referenced from both sections; an ES module with the same URL
 * evaluates once per document, and the flag covers a re-render that somehow
 * re-runs it.
 */

const HOSTS = '.ghp-offer__form-host, .ghp-satc__form-host, .gh-sprod__form-host';
const MOBILE = '(max-width: 749px)';
const FALLBACK_CART_URL = '/cart';

if (!window.__ghpCartAfterAdd) {
  window.__ghpCartAfterAdd = true;

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.action !== 'add') return;

    // product-form-component dispatches the event on itself, so the host is an
    // ancestor of the target whenever the add came from one of our sections.
    const host = event.target instanceof Element ? event.target.closest(HOSTS) : null;
    if (!host) return;

    const cartUrl = host.dataset.ghpCartUrl || FALLBACK_CART_URL;

    event.promise
      ?.then(({ detail }) => {
        // The line was rejected (sold out, quantity rule). The component has
        // already put a message under the button — leaving the shopper on it is
        // the point, so no drawer and no navigation.
        if (detail?.didError) return;

        if (window.matchMedia(MOBILE).matches) {
          window.location.assign(cartUrl);
          return;
        }

        const drawer = document.getElementById('cart-drawer');

        // No drawer in the DOM when settings.cart_type is 'page', and no open()
        // if <theme-drawer> never upgraded. Either way the cart page is the
        // honest destination — never swallow the click.
        if (!drawer || typeof drawer.open !== 'function') {
          window.location.assign(cartUrl);
          return;
        }

        if (!drawer.isOpen) drawer.open();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ghp-cart-after-add]', error);
      });
  });
}
